import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import FromAndToDatePicker from "../../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import GlobalMultiSelectNew from "../../../components/mui/GlobalMultiSelectNew";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import { useLocation } from "react-router-dom";
import ToolTip from "../../../components/ToolTip/ToolTip";
import { getTrLeadData } from "../../../redux/features/srtSlice";
import { Tutor_Replace_Leads_Head } from "../../../components/datagrid/srt/TrleadsTablehead";

const Trtstudentdetails = () => {
  const userProfile = JSON.parse(localStorage.getItem("cred")).profile;

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const croID = searchParams.get("croId");
  const trainerId = searchParams.get("trainerId");
  const fromdate = searchParams.get("fromDate");
  const todate = searchParams.get("toDate");
  const projectId = searchParams.get("projectId");

  const [fromDate, setFromDate] = useState(
    fromdate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    todate || dayjs().endOf("month").format("YYYY-MM-DD")
  );

  const dispatch = useDispatch();

  const { trleaddata, loading } = useSelector((state) => state.srt);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  useEffect(() => {
    dispatch(
      getTrLeadData({
        page: pageNum,
        limit: gridSize,
        search: search,
        croId: croID || undefined,
        trainerId: trainerId || undefined,
        fromDate: fromDate,
        toDate: toDate,
        projectId: projectId,
      })
    );
  }, [dispatch, fromDate, toDate, pageNum, gridSize, croID, search]);

  return (
    <GlobalWrapper title={"Student Details"}>
      <Box sx={{ display: "flex", mb: 1, gap: "10px", flexDirection: "row" }}>
        <FromAndToDatePicker
          disabled={false}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Tutor_Replace_Leads_Head}
          rows={trleaddata.data}
          meta={trleaddata?.meta?.totalRecords || 0}
          rowUniqueId="slNo"
          loading={loading}
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default Trtstudentdetails;
